import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import classNames from "classnames";
import { SpinnerBackdrop } from "banafo-design-system";
import getConfigEnumText from "src/common/utils/config/configEnumText";
import { CONVERSATION_DIRECTIONS_ENUM, CONVERSATION_TYPE_PHONE_CALL, CONVERSATION_TYPES_ENUM } from "src/features/conversations/config";
import DetailsData from "src/features/conversation/DetailsData";
import DetailsDataContact from "src/features/conversation/DetailsDataContact";
import { formattedDuration } from "src/features/auth/util/dateTime";
import { Title } from "@mantine/core";
import "./DetailsSection.scss";
import { useGetCallQuery } from "src/features/conversations/conversationApi";
import AiInsights from "src/features/conversation/AiInsights";
import { useEffect, useState } from "react";
import { AiStatus } from "src/features/conversations/types";
import { useGetUsagesQuery } from "src/features/sidebar/sidebarSlice";
const DetailsSection = ({ className }) => {
    const { callId } = useParams();
    const location = useLocation();
    const { t } = useTranslation();
    const [shouldPollCall, setShouldPollCall] = useState(false);
    const { isLoading: isLoadingUsages } = useGetUsagesQuery(location.pathname);
    const { data: { 
    // @ts-ignore
    aiStatus, startedAt, duration, source, type, remotePhone, direction, contact } = {}, isLoading } = useGetCallQuery(callId, {
        pollingInterval: shouldPollCall ? 10000 : 0,
        skipPollingIfUnfocused: true,
    });
    useEffect(() => {
        setShouldPollCall(aiStatus && AiStatus.Processing === aiStatus);
    }, [aiStatus]);
    if (isLoading || isLoadingUsages) {
        return _jsx(SpinnerBackdrop, {});
    }
    return (_jsxs("div", { className: classNames('conversation-details', className), children: [_jsx(AiInsights, {}), _jsx(Title, { order: 5, fw: "bold", mb: "md", tt: "uppercase", children: t('Record.details_') }), _jsx(DetailsData, { title: t('Conversation.type_'), text: getConfigEnumText(CONVERSATION_TYPES_ENUM, type) }), _jsx(DetailsData, { title: t('Started.At_'), text: startedAt ? moment(startedAt).format('YYYY-MM-DD HH:mm:ss') : '-' }), _jsx(DetailsData, { title: t('Duration_'), text: duration ? formattedDuration(duration, 'HH:mm:ss') : '-' }), _jsx(DetailsData, { title: t('Source_'), text: source }), type === CONVERSATION_TYPE_PHONE_CALL && _jsxs(_Fragment, { children: [_jsx(DetailsData, { title: t('Phone_'), text: remotePhone }), _jsx(DetailsData, { title: t('Direction_'), text: getConfigEnumText(CONVERSATION_DIRECTIONS_ENUM, direction) })] }), contact && _jsx(DetailsDataContact, { title: t('Contact_'), contact: contact })] }));
};
export default DetailsSection;
